import { render } from "./CrosswordPlugin.vue?vue&type=template&id=2111bfde&scoped=true"
import script from "./CrosswordPlugin.vue?vue&type=script&lang=js"
export * from "./CrosswordPlugin.vue?vue&type=script&lang=js"

import "./CrosswordPlugin.vue?vue&type=style&index=0&id=2111bfde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2111bfde"]])

export default __exports__